/**
 * multi-session-error-codes
 * Adapted from @daveyplate/better-auth-ui
 * Enhanced for @bettercone/ui
 */

export const MULTI_SESSION_ERROR_CODES = {
    INVALID_SESSION_TOKEN: "Invalid session token"
}
